import { Link } from '@tanstack/react-router';
import { Button, Result } from 'antd';

export const NotFoundPage = () => (
  <Result
    status="404"
    title="404"
    subTitle="页面不存在或你没有访问权限"
    extra={
      <Link to="/">
        <Button type="primary">返回首页</Button>
      </Link>
    }
  />
);
